export const JWT_CONFIG = {
  refreshTokenUrl: 'auth/refresh-token',
  jwtCookieName: 'jwt',
}
